/* Nanshy Draft 8 - quick add, product form, variant picker, subscriptions, description clamp, sticky bar, click-to-load videos, load more */
(function () {
  function openDrawerWith(data) {
    var drawer = document.querySelector('cart-drawer');
    drawer.classList.remove('is-empty');
    drawer.renderContents(data);
  }

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest && e.target.closest('form[data-d8-quick-add]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    e.preventDefault();
    var fid = form.getAttribute('id');
    var btns = fid
      ? document.querySelectorAll('button[form="' + fid + '"], [id="' + fid + '"] button[type="submit"]')
      : form.querySelectorAll('button[type="submit"]');
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var q = form.querySelector('[name="quantity"]');
    var plan = form.querySelector('[name="selling_plan"]:not([disabled])');
    var body = {
      id: form.querySelector('[name="id"]').value,
      quantity: q ? Math.max(1, parseInt(q.value, 10) || 1) : 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    if (plan && plan.value) body.selling_plan = plan.value;
    try {
      var res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await res.json();
      if (data.status) { alert(data.description || data.message); return; }
      openDrawerWith(data);
    } catch (err) {
      form.submit();
    } finally {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); if (!b.hasAttribute('data-d8-soldout')) b.disabled = false; });
    }
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-d8-embed]');
    if (b) {
      var f = document.createElement('iframe');
      f.src = b.getAttribute('data-d8-embed');
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.title = b.getAttribute('aria-label') || 'Video';
      b.replaceWith(f);
      return;
    }
    var qb = e.target.closest && e.target.closest('[data-d8-qty]');
    if (qb) {
      var input = qb.parentNode.querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + parseInt(qb.getAttribute('data-d8-qty'), 10);
      input.value = Math.max(1, v);
      return;
    }
    var dt = e.target.closest && e.target.closest('[data-d8-desc-toggle]');
    if (dt) {
      var body = document.getElementById(dt.getAttribute('aria-controls'));
      var open = body.classList.toggle('is-open');
      dt.setAttribute('aria-expanded', open ? 'true' : 'false');
      dt.textContent = open ? 'See less' : 'See more';
      return;
    }
    var lm = e.target.closest && e.target.closest('[data-d8-load-more]');
    if (lm) {
      e.preventDefault();
      lm.setAttribute('aria-busy', 'true');
      fetch(lm.href).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector('[data-d8-grid]');
        var newItems = doc.querySelectorAll('[data-d8-grid] > [data-d8-item]');
        newItems.forEach(function (n) { grid.appendChild(n); });
        var next = doc.querySelector('[data-d8-load-more]');
        if (next) { lm.href = next.href; lm.removeAttribute('aria-busy'); } else { lm.remove(); }
      });
    }
  });

  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest && e.target.closest('[data-d8-hover-video]');
    if (!c) return;
    var v = c.querySelector('video');
    if (v && v.paused) { v.play().catch(function () {}); }
  });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('[data-d8-hover-video]');
    if (!c || c.contains(e.relatedTarget)) return;
    var v = c.querySelector('video');
    if (v) v.pause();
  });

  function initDesc(root) {
    root.querySelectorAll('[data-d8-desc]').forEach(function (d) {
      d.querySelectorAll('p, div').forEach(function (p) {
        if (!p.textContent.replace(/ /g, ' ').trim() && !p.querySelector('img, iframe, video, svg')) p.classList.add('d8-empty');
      });
      var btn = root.querySelector('[data-d8-desc-toggle][aria-controls="' + d.id + '"]');
      if (btn && d.scrollHeight > d.clientHeight + 4) btn.hidden = false;
    });
  }

  function initProduct(root) {
    initDesc(root);
    var json = root.querySelector('[data-d8-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('[data-d8-variant-id]');
    var atc = root.querySelector('[data-d8-atc]');
    var planSel = root.querySelector('[data-d8-plan]');
    var freq = root.querySelector('[data-d8-freq]');
    var current = variants.find(function (x) { return String(x.id) === String(idInput.value); }) || variants[0];

    function subscribing() {
      var r = root.querySelector('[data-d8-purchase]:checked');
      return r && r.value === 'subscribe';
    }
    function render() {
      var v = current;
      var sub = subscribing();
      var planPrice = planSel && v.plans ? v.plans[planSel.value] : null;
      root.querySelectorAll('[data-d8-price]').forEach(function (p) { p.textContent = v.price; });
      root.querySelectorAll('[data-d8-plan-price]').forEach(function (p) { p.textContent = planPrice || ''; });
      if (planSel) { planSel.disabled = !sub; }
      if (freq) { freq.hidden = !sub; }
      if (atc) {
        var t = atc.querySelector('[data-d8-atc-text]');
        var sfx = atc.querySelector('[data-d8-atc-suffix]');
        var ap = atc.querySelector('[data-d8-atc-price]');
        if (t) t.textContent = !v.available ? 'Sold out' : (sub ? 'Subscribe' : 'Add to basket');
        if (ap) ap.textContent = sub && planPrice ? planPrice + ' per delivery' : v.price;
        if (sfx) sfx.style.display = v.available ? '' : 'none';
      }
      document.querySelectorAll('[data-d8-atc], [data-d8-sticky-atc]').forEach(function (b) {
        if (v.available) { b.disabled = false; b.removeAttribute('data-d8-soldout'); }
        else { b.disabled = true; b.setAttribute('data-d8-soldout', ''); }
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('.d8-opt')) {
        var chosen = [];
        root.querySelectorAll('.d8-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          chosen.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-d8-opt-value]');
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        current = v;
        idInput.value = v.id;
        document.querySelectorAll('[data-d8-sticky-variant]').forEach(function (p) { p.textContent = v.title; });
        var main = root.querySelector('[data-d8-main-media] img');
        if (main && v.img) { main.removeAttribute('srcset'); main.src = v.img; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        render();
        return;
      }
      if (e.target.matches('[data-d8-purchase], [data-d8-plan]')) render();
    });
    render();

    var sticky = root.querySelector('[data-d8-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', below);
          sticky.setAttribute('aria-hidden', below ? 'false' : 'true');
          var sb = sticky.querySelector('button');
          if (sb) sb.tabIndex = below ? 0 : -1;
        });
      });
      io.observe(atc);
    }
  }

  function boot() { document.querySelectorAll('[data-d8-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
